import { render, staticRenderFns } from "./CheckinAssignments.vue?vue&type=template&id=182a89c6&"
import script from "./CheckinAssignments.vue?vue&type=script&lang=ts&"
export * from "./CheckinAssignments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports